const titulo = (titulo) => {
  return `<h1>
    <strong
      class="ql-custom-titulo"
      style="background-color: transparent; color: rgb(0, 0, 0); font-size: 1.4em;"
    >
      ${titulo}
    </strong>
  </h1>`;
};

const authorAndReviwer = (author, reviwer) => {
  return `
    <div style="
      display: flex;
      font-size: 0.7em;
      flex-direction: column;
    ">
      <i>Professor(a) autor(a): ${author || "Equipe Aprovamais"}</i>
      <i>Professor(a) revisor(a): ${reviwer || "Equipe Aprovamais"}</i>
    </div>
  `;
};

const sumary = (sumary) => {
  const s = sumary
    .map((item) => {
      if (!item.data) return "";

      let s = `<li data-list="disc">
        <span class="ql-ui" contenteditable="false"></span>
        <p class="ql-custom-objetivos">
          ${item.data}
        </p>
      </li>
      `;

      s += item.itens
        .map((item) => {
          if (!item) return "";

          return `
      <li data-list="disc" class="indent-1">
        <span class="ql-ui" contenteditable="false"></span>
        <p class="ql-custom-objetivos">
          ${item}
        </p>
      </li>
      `;
        })
        .join("");

      return s;
    })
    .join("");

  return `
  <p class="ql-custom-topico">
    Sumário
  </p>
  <ul>
    ${s}
  </ul>
  `;
};

const goals = (goals) => {
  const newGoals = goals.map((goal) => {
    if (!goal) return "";

    return `
    <li data-list="disc">
      <span class="ql-ui" contenteditable="false"></span>
      <p class="ql-custom-objetivos">
        ${goal}
      </p>
    </li>`;
  });

  const newGoalsString = newGoals.join("");

  if (newGoalsString.length < 1) return "";

  return `
  <p class="ql-custom-topico">Seus objetivos neste módulo</p>
  <ul>
    ${newGoalsString}
  </ul>
  `;
};

const comment = (com) => {
  if (!com) return "";

  return `
    <div>
      <p class="ql-custom-topico">
        Leitura Prévia
      </p>
      <p class="ql-custom-comentario" style="margin-top: 0">
        ${com}
      </p>
    </div>
  `;
};

const topic = (topics) =>
  topics
    .map(
      (topic) => `
  <h2 class="ql-custom-topico">
    ${topic.data}
  </h2>
  <div class="ql-editor">
    ${topic.itens[0].itens[0].htmls}
  </div>
`
    )
    .join("");

const pensamento = (p) => {
  let key = 0;

  const pensamentos = p
    .map((pensamento) => {
      if (!pensamento) return "";

      key++;

      return `
    <li data-list="ordered">
      <span class="ql-ui" contenteditable="false"></span>
      ${key}. ${pensamento}
    </li>
    `;
    })
    .join("");

  return `
    <p class="ql-custom-topico">Hora da reflexão</p>
    <p style="margin: 0; margin-bottom: 0.5em" class="ql-custom-comentario">Tente responder as perguntas com as suas palavras. Se tiver dificuldade, consulte o material. Pedimos também para que grave um áudio com as respostas, que servirá apenas para a sua própria revisão no futuro.</p>
    <ul>
      ${pensamentos}
    </ul>
  `;
};

const glossary = (glo) => {
  const gloss = glo
    .map((g) => {
      if (!g.word || !g.meaning) return "";

      return `
      <li data-list="disc">
        <span class="ql-ui" contenteditable="false"></span>
        <b>${g.word}</b>: ${g.meaning}
      </li>
    `;
    })
    .join("");

  if (gloss.length < 1) return "";

  return `
    <p>
      <strong class="ql-custom-objetivos">
        Glossário
      </strong>
    </p>
    <ul>
      ${gloss}
    </ul>
  `;
};

const bibliography = (glo) => {
  const gloss = glo
    .map((g) => {
      if (!g.text) return "";

      if (g.link) {
        return `
      <li data-list="bullet">
        <span class="ql-ui" contenteditable="false"></span>
        <a href="${g.link}" target="_blank">${g.text}</a>
      </li>
      `;
      } else {
        return `
        <li data-list="bullet">
          <span class="ql-ui" contenteditable="false"></span>
          ${g.text}
        </li>
      `;
      }
    })
    .join("");

  if (gloss.length < 1) return "";

  return `
    <p>
      <strong class="ql-custom-objetivos">
        Bibliografia
      </strong>
    </p>
    <ul>
      ${gloss}
    </ul>
  `;
};

export default function (data) {
  let body = titulo(data[0].data);

  body += authorAndReviwer(data[9].data, data[10].data);

  body += sumary(data[1].itens);

  body += goals(data[2].itens);

  body += '<hr style="margin-top: 2em; border-color: #fffdfd;">';

  body += comment(data[3].data);

  body += topic(data[4].itens);

  body += pensamento(data[5].itens);

  body += glossary(data[6].itens);

  body += bibliography(data[7].itens);

  return `<!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="utf-8"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.11.1/dist/katex.min.css" integrity="sha384-zB1R0rpPzHqg7Kpt0Aljp8JPLqbXI3bhnPWROx27a9N0Ll6ZP/+DiW/UqRcLbRjq" crossorigin="anonymous">
        <link href="https://cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet">
        <link rel="stylesheet" href="https://firebasestorage.googleapis.com/v0/b/aprovamais-oab.appspot.com/o/configuracoes%2Fcss%2Faprovamais.css?alt=media&token=613e13ba-1b8a-46a8-847e-ad9054c96037">
      </head>
      <body>
        <section id="content-container" style="font-size: 22px">
          ${body}
          <div style="margin-top: 2em">
            <h3 class="ql-align-center ql-custom-topico">
              <strong style="background-color: transparent; color: rgb(67, 67, 67);">
                Material protegido por Copyright
              </strong>
            </h3>
            <p class="ql-align-center">
              <strong style="background-color: transparent; color: rgb(0, 0, 0);">
                Este material é protegido pela Lei de Direitos Autorais (Lei Nº 9.610), sendo vedada a reprodução, distribuição ou comercialização de qualquer material ou conteúdo dele obtido, sem a prévia e expressa autorização da GoBrain Editora Digital Ltda.
              </strong>
            </p>
          </div>
        </section>
      </body>
    </html>`;
}
